import React, { useEffect, useState } from "react";
import "./Winner_Modal.css";
import { Modal } from "react-bootstrap";
import Win_Lottie from "../../../../Animation/Win_Lottie/Win_Lottie";
import Congratulation_Modal from "../Congratulation_Modal/Congratulation_Modal";
import { formatAmount, getBetSummary } from "../../../../../utils/common";

function Winner_Modal({ winningBets, resultData, show, onHide, modalCongShow, ...props }) {

  const [modalShow, setModalShow] = useState(false);


  const summary = getBetSummary(winningBets);
  // const summary = {
  //   bets: [
  //     { bet_on: "8", bet_type: "number", amount: 10, profit: 0, loss: 10, result: "loss" },
  //     { bet_on: "Voilet", bet_type: "color", amount: 10, profit: 0, loss: 10, result: "loss" },
  //     { bet_on: "Red", bet_type: "color", amount: 10, profit: 0, loss: 10, result: "loss" },
  //     { bet_on: "green", bet_type: "color", amount: 10, profit: 0, loss: 10, result: "loss" },
  //     { bet_on: "Small", bet_type: "size", amount: 10, profit: 20, loss: 0, result: "win" },
  //   ],
  //   totalBetAmount: "30.00",
  //   totalProfit: "20.00",
  //   totalLoss: "20.00",
  //   netAmount: "0.00",
  // }

  return (
    <>
      <Modal
        {...props}
        show={show}
        onHide={onHide}
        centered
        size="sm"
        backdrop="static"
        className="Winner_Modal Common_modal"
      >
        <Modal.Body>
          {modalCongShow &&
            <div className="img_holder">
              <img
                src="/assets/images/Congratulations_modal/bg.png"
                className="cap_img"
                alt="cap"
              />
              <div className="lottie_holder">
                <Win_Lottie />
              </div>
            </div>

          }
          <div className="winner_content_holder">
            <div className="img_holder">
              <img
                src="/assets/images/Winner_Modal/bg.png"
                className="bg_img"
                alt="winner"
              />




              <div className="result_box">
                <span className="number">{resultData?.number}</span>
                <span className={`result_color ${resultData?.color?.toLowerCase().replace(",", "_")}`}></span>
                <span className="type">{resultData?.size}</span>
              </div>

              <div className="period_text">
                Period: {resultData?.Period?.period || ""}
              </div>

              <div className="amount_box">
                <img
                  src="/assets/images/icons/rupee.png"
                  alt="coin"
                  className="coin_icon"
                />
                <span>{formatAmount(summary?.totalProfit)}</span>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>


    </>
  );
}

export default Winner_Modal;